// Generated by purs version 0.15.15
import * as Data_Lens_Record from "../Data.Lens.Record/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
var prop = function (dictIsSymbol) {
    var prop1 = Data_Lens_Record.prop(dictIsSymbol)()();
    return function () {
        return function () {
            return function (dictStrong) {
                return prop1(Type_Proxy["Proxy"].value)(dictStrong);
            };
        };
    };
};
export {
    prop
};
